import { useMemo } from 'react';

import { formatCurrency, type FormatCurrencyOptions } from './formatCurrency';
import { useGetUserCurrencyCode } from '@/api/REST/userMe';
import { useLocaleStore } from '@/stores/locale';

export const useFormatCurrency = (
  number: number,
  options: FormatCurrencyOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currencyDisplay: 'code',
  },
) => {
  const { lang } = useLocaleStore();
  const { currencyCode } = useGetUserCurrencyCode();

  const currency = options.currency ?? currencyCode;

  return useMemo(() => {
    return formatCurrency(number, lang, currency, options);
  }, [
    number,
    lang,
    currency,
    options.currencyDisplay,
    options.minimumFractionDigits,
    options.maximumFractionDigits,
  ]);
};
